<template>
  <div>
    <!--Скелет поиска-->
    <!-- <div class="models-header models-header--skeleton mb-9 bg-skeleton"></div> -->
    <div class="models-header mb-9">
      <div class="models-header_sorting-wrap d-none d-md-block">

      </div>
      <div class="models-header_search-wrap d-flex">
        <i class="icon-search1"></i>
        <input
          class="search-global search-global--library"
          id="searchModels"
          v-model="search"
          ref="inputSearch"
          placeholder="Поиск по плагинам"
        />
        <div class="search_btn">
          <i class="icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="plugin-container" v-if="plugins.length">
      <a
        v-for="plugin of filteredPlugins"
        :key="plugin.id"
        :href="plugin.url"
        target="_blank"
        class="plugin d-flex align-center"
      >
        <div class="d-flex align-center p-9">
          <div class="d-flex align-center"><img :src="plugin.logo" alt="" class="plugin__logo"></div>
          <div class="d-flex align-center flex-column pl-6">
            <bim-text type="medium" bold class="pb-1 d-flex align-center">
              {{ plugin.title }}
              <img v-if="plugin.isBIMLIBPlugin" class="ml-1" alt="" src="/dist/assets/front_white/img/landing_plugin/icon-done-filled-small.svg" />
            </bim-text>
          </div>
        </div>
      </a>
    </div>
    <p v-if="isFirstLoadSuccess && !filteredPlugins.length" class="h1 text-center soft_light-color mb-10">{{$t('Ничего не найдено')}}</p>
  </div>
</template>

<script>
class Plugin {
  constructor({
    id,
    url,
    logo,
    title,
    company,
    weight,
    status="Published",
  }) {
    this.id = id;
    this.url = url;
    this.logo = logo;
    this.title = title;
    this.company = company;
    this.weight = weight;
    this.status = status;
  }

  get isBIMLIBPlugin() {
    return this.company === "BIMLIB"
  }

  get isDraft() {
    return this.status === "Draft"
  }
}

const customPlugins = [
  new Plugin({
    id: "master_specification",
    url: "/plugin/",
    logo: "/dist/assets/front_white/img/landing_plugin/plugin__settings.svg",
    title: "Мастер спецификаций",
    company: "BIMLIB",
    weight: -1,
  })
]

export default {
  data () {
    return {
      isFirstLoadSuccess: false,
      plugins: [],
      search: "",
    }
  },
  async created () {
    await this.getPlugins();
    this.isFirstLoadSuccess = true;
  },
  computed: {
    langPlugins() {
      const plugins = this.plugins.map(p => {
        const { title, companyNameShort: company, status_lang: status, weight } = p.lang_versions[1]
        return new Plugin({
          id: p.id,
          url: `/manufacturer/${p.company_alias}/${p.company_id}?tab=plugins`,
          logo: '/uploads/' + p.company_logo,
          title,
          company,
          status,
          weight: weight && parseInt(weight) || 1
        })
      })
      return plugins.concat(customPlugins)
    },
    /**
     * Опубликованные плагины
     */
    notDraftPlugins() {
      return this.langPlugins.filter(p => !p.isDraft)
    },
    /**
     * Сортировка по позиции
     */
    sortedPlugins() {
      return this.notDraftPlugins.sort((plugin1, plugin2) => {
        return plugin1.weight - plugin2.weight
      })
    },
    /**
     * Плагины, отфильтрованные поиском
     */
    filteredPlugins() {
      const low = str => String(str).toLowerCase()
      const includes = (str1, str2) => low(str1).includes(low(str2))
      const searchPlugin = p => {
        return (
          includes(p.title, this.search)
        )
      }

      return this.sortedPlugins.filter(searchPlugin)
    },
  },

  methods: {
    async getPlugins() {
      this.plugins = await this.$store.dispatch('getPluginsList')
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.models-header {
  height           : 48px;
  background-color : $white-color;

  display          : flex;
  border-radius    : 5px;
  box-shadow       : 0 3px 8px 0 rgba(0, 0, 0, 0.05);
  border           : solid 1px $white-color-500;

  &--skeleton {
    width         : 100%;
    border-radius : 3px;
  }

  &_sorting-wrap {
    border-right : solid 1px $white-color-500;
  }

  &_search-wrap {
    position  : relative;
    height    : 100%;
    flex-grow : 1;

    i.icon-search1 {
      position  : absolute;
      left      : 14px;
      top       : 50%;
      transform : translateY(-50%);
      opacity   : .5;
    }
  }
}

.plugin-container {
  display: flex;
  flex-wrap: wrap;

  .plugin {
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.05);
    background-color: $white-color;
    min-height: 108px;
    margin-bottom: 32px;
    cursor: pointer;

    margin-right: 32px;
    flex: 0 1 31.4%;

    @media screen and (max-width: $breakpoint-xxl) {
      flex: 0 1 31.3%;
    }

    @media screen and (max-width: $breakpoint-xl) {
      flex: 0 1 30.8%;
    }

    @media screen and (min-width: $breakpoint-lg) {
      &:nth-child(3n) {
        margin-right: 0;
      }
    }

    @media screen and (max-width: $breakpoint-lg) {
      flex: 0 1 47.7%;
      &:nth-child(even) {
        margin-right: 0;
      }
    }

    @media screen and (max-width: $breakpoint-md) {
      flex: 0 1 100%;
      margin-right: 0;
    }

    &:hover {
      box-shadow: none;

      box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.01);
    }

    .plugin__logo {
      max-width: 60px;
      max-height: 60px;
      width: 60px;
      height: 60px;
      object-fit: contain;
    }
  }
}
</style>
